import styled from 'styled-components';

const BoxesStyles = styled.section`
  padding-top: 2.75rem;
  text-align: center;
  background-color: var(--color-${(props) => props?.bgColor});

  .heading-wrapper {
    margin: 0 0 3rem;

    .heading {
      color: ${(props) =>
        props?.bgColor === 'charcoal' || props?.bgColor === 'bark'
          ? 'var(--color-white)'
          : 'var(--color-charcoal)'};
    }
  }

  .box {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    flex-direction: column;
    margin: 0 auto 2.75rem;
    width: 100%;
    color: #fff;
    background-color: ${(props) =>
      props?.bgColor === 'charcoal'
        ? 'var(--color-bark)'
        : 'var(--color-charcoal)'};

    .top,
    .bottom {
      width: 100%;
    }

    .top {
      margin-bottom: auto;

      .img {
        width: 100%;
        height: 200px;
      }
    }

    .bottom {
      align-items: flex-start;
      padding: 1.875rem 1.563rem;

      .subheading {
        margin: -0.75rem 0 1rem;
      }

      .text {
        margin: 0 auto;
        max-width: ${(props) => (props?.wideText ? '90%' : '17rem')};

        ul,
        ol {
          list-style-position: inside;
        }
      }

      .btn-group {
        margin: 1.5rem 0 0;
      }
    }

    &:last-child {
      margin: 0;
    }

    &:nth-child(even) {
      background-color: ${(props) =>
        props?.bgColor === 'bark'
          ? 'var(--color-charcoal)'
          : 'var(--color-bark)'};
    }
  }

  @media (min-width: 768px) {
    .heading-wrapper {
      margin: 0 0 4rem;
    }

    .box {
      margin: 0 auto 3.75rem;

      .top {
        .img {
          height: 350px;
        }
      }
    }
  }

  @media (min-width: 992px) {
    .box {
      width: calc(50% - 4rem);
      max-width: 43rem;

      .bottom {
        padding: 2.688rem 1.563rem;

        .text {
          max-width: ${(props) => (props?.wideText ? '90%' : '20rem')};
        }
      }

      &:last-child {
        margin: 0 auto 3.75rem;
      }
    }
  }

  @media (min-width: 1200px) {
    .box {
      width: calc(50% - 3.5rem);
    }
  }

  @media (min-width: 1400px) {
    .box {
      width: calc(50% - 4rem);
    }
  }
`;

export default BoxesStyles;
